import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esCommon from './locales/es/common.json';
import enCommon from './locales/en/common.json';
import esLanding from './locales/es/landing.json';
import enLanding from './locales/en/landing.json';
import esServices from './locales/es/services.json';
import enServices from './locales/en/services.json';
import esPortfolio from './locales/es/portfolio.json';
import enPortfolio from './locales/en/portfolio.json';
import esProcess from './locales/es/process.json';
import enProcess from './locales/en/process.json';
import esAbout from './locales/es/about.json';
import enAbout from './locales/en/about.json';
import esFaq from './locales/es/faq.json';
import enFaq from './locales/en/faq.json';
import esContact from './locales/es/contact.json';
import enContact from './locales/en/contact.json';
import esLegal from './locales/es/legal.json';
import enLegal from './locales/en/legal.json';
import esAuth from './locales/es/auth.json';
import enAuth from './locales/en/auth.json';
import esPortal from './locales/es/portal.json';
import enPortal from './locales/en/portal.json';
import esAdmin from './locales/es/admin.json';
import enAdmin from './locales/en/admin.json';
import esEditor from './locales/es/editor.json';
import enEditor from './locales/en/editor.json';
import esFeeds from './locales/es/feeds.json';
import enFeeds from './locales/en/feeds.json';
import esSeoPages from './locales/es/seo-pages.json';
import enSeoPages from './locales/en/seo-pages.json';

export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'es';

export function isSupportedLanguage(value: string | undefined | null): value is SupportedLanguage {
  return value === 'es' || value === 'en';
}

const ns = [
  'common',
  'landing',
  'services',
  'portfolio',
  'process',
  'about',
  'faq',
  'contact',
  'legal',
  'auth',
  'portal',
  'admin',
  'editor',
  'feeds',
  'seoPages',
] as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common: esCommon,
        landing: esLanding,
        services: esServices,
        portfolio: esPortfolio,
        process: esProcess,
        about: esAbout,
        faq: esFaq,
        contact: esContact,
        legal: esLegal,
        auth: esAuth,
        portal: esPortal,
        admin: esAdmin,
        editor: esEditor,
        feeds: esFeeds,
        seoPages: esSeoPages,
      },
      en: {
        common: enCommon,
        landing: enLanding,
        services: enServices,
        portfolio: enPortfolio,
        process: enProcess,
        about: enAbout,
        faq: enFaq,
        contact: enContact,
        legal: enLegal,
        auth: enAuth,
        portal: enPortal,
        admin: enAdmin,
        editor: enEditor,
        feeds: enFeeds,
        seoPages: enSeoPages,
      },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    defaultNS: 'common',
    ns: [...ns],
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
      lookupLocalStorage: 'gtfs-lang',
    },
    returnEmptyString: false,
  });

export default i18n;
